import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./NavbarStyle.css";

import {
  BackArrowIcon2,
  New_ScrollX2025,
  NotificationsIcon,
  SX_dashboard_Help_icon,
} from "../../../assets/icons";

import { useDispatch, useSelector } from "react-redux";
import { getDefaultSettings } from "../../../Redux/actions/defaultSettingsActions";

// ========================================================================================
// Project Layouts
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  addNotifications,
  deleteNotifications,
  getNotification,
  updateNotification,
} from "../../../Redux/actions/commonActtion";

import { DropdownForNotiFy } from "../../../Components";
import Setting from "../../Setting/Setting";

const NOTIFICATION_PAGE_SIZE = 15;

const Navbar = ({
  isProjectOpen,
  renderOpen,
  setRenderOpen,
}) => {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const notificationBtnRef = useRef(null);
  const project = useSelector((state) => state.project);

  const notifications = useSelector(
    (state) => state.commonReducer.notifications
  );
  const unreadCount = useSelector(
    (state) =>
      state.commonReducer.unreadCount ??
      state.commonReducer.notificationsWithReadStatus?.length ??
      0
  );
  const notificationsHasMore = useSelector(
    (state) => state.commonReducer.notificationsHasMore
  );
  const notificationsPage = useSelector(
    (state) => state.commonReducer.notificationsPage || 1
  );
  const notificationsLoading = useSelector(
    (state) => state.commonReducer.notificationsLoading
  );

  useEffect(() => {
    fetchProjectSettings();
    dispatch(getNotification({ page_no: 1, limit: 0 }));
  }, []);

  const fetchProjectSettings = () => {
    dispatch(getDefaultSettings());
  };

  const getAllNotification = async () => {
    if (isOptionsVisible) {
      setIsOptionsVisible(false);
      return;
    }
    if (unreadCount > 0) {
      await dispatch(updateNotification());
    }
    setIsOptionsVisible(true);
    await dispatch(
      getNotification({
        page_no: 1,
        limit: NOTIFICATION_PAGE_SIZE,
        append: false,
      })
    );
  };

  const fetchMoreData = useCallback(() => {
    if (!notificationsHasMore || notificationsLoading) return;
    dispatch(
      getNotification({
        page_no: notificationsPage + 1,
        limit: NOTIFICATION_PAGE_SIZE,
        append: true,
      })
    );
  }, [dispatch, notificationsHasMore, notificationsLoading, notificationsPage]);

  const handleDeleteNotification = async (id) => {
    await dispatch(deleteNotifications({ notification_id: id }));
  };

  const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    if (firstName) {
      return `${firstName.charAt(0).toUpperCase()}`;
    }
    return "U";
  };

  const getBackgroundColor = () => {
    return "#413CAA";
  };

  const CloseButton = ({ closeToast }) => (
    <i className="material-icons w-7 flex justify-center cursor-pointer not-italic" onClick={closeToast}>✖</i>
  );

  const navigateHandler = () => {
    if (renderOpen) {
      setRenderOpen(false);
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <>
      <nav id="navbar_1" className="w-full Pro_navbarDash h-full flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl bg-[#0d0b18]">
        <ToastContainer closeButton={CloseButton} />

        <div className="w-full h-full flex flex-wrap items-center justify-between pl-[1%] pr-[2%]">
          <div className="w-[15%] flex justify-between items-center">
            <button className={isProjectOpen ? "hidden" : "w-[15%] flex items-center"} onClick={navigateHandler}>
              <img className="ml-2 w-[11px] cursor-pointer" src={BackArrowIcon2} alt=""/>
            </button>
            <div className="w-[85%] fixed left-[60px] flex items-center">
              <img className="w-[35px] " src={New_ScrollX2025} />
              <span className="ml-[10px] Syne text-xl font-light tracking-wide ">ScrollX.io</span>
            </div>
          </div>

          <div className="w-[52%] flex justify-center items-center">
            <h1 className="manrope-600 text-[15px] text-white font-light">{isProjectOpen ? "Dashboard" : project?.title?.toUpperCase()}</h1>
          </div>

          <div className="w-[30%] flex justify-end items-center">
            <div className="flex items-center">
              {isProjectOpen ? (
                <div className="mr-[20px] manrope-600 text-[15px]  text-white">
                  <Link to="/dashboard/myrenders"><h2>My Renders </h2></Link>
                </div>
              ) : (
                <div className="flex  mx-3  px-1 notification ">
                  <button ref={notificationBtnRef} type="button" onClick={getAllNotification}>
                    <img className="pro_navabr_Notifications opacity-75" src={NotificationsIcon} alt=""/>
                  </button>
                  {unreadCount > 0 && (<span className="badge">{unreadCount}</span>)}
                </div>
              )}
              
              <div className="flex m-auto">
                <button className="w-[35px] h-[35px] rounded-full" onClick={() => setIsSettingOpen(true)} style={{ backgroundColor: getBackgroundColor() }}>
                  <div className="flex justify-center items-center text-white text-xl manrope-600 w-[35px] h-[35px] rounded-full ">
                    <span className="manrope-600 text-white text-xl text-center ">{getUserInitials()}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <Setting
        isSettingOpen={isSettingOpen}
        setIsSettingOpen={setIsSettingOpen}
      />
      <DropdownForNotiFy
        isOptionsVisible={isOptionsVisible}
        setIsOptionsVisible={setIsOptionsVisible}
        options={notifications}
        fetchMoreData={fetchMoreData}
        handleDeleteNotification={handleDeleteNotification}
        anchorRef={notificationBtnRef}
        hasMore={notificationsHasMore}
        isLoadingMore={notificationsLoading}
      />
    </>
  );
};

export default Navbar;
